module.exports = __webpack_public_path__ + "img/left-3.03ffdc73.png";